import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ControlOptions } from "../card/card.models";
import {
  CardCategories,
  CardDeckType,
  CardModel,
} from "../../../swagger/api.client.generated";

@Component({
  selector: "app-card-expanded",
  templateUrl: "./card-expanded.component.html",
  styleUrls: ["./card-expanded.component.scss"],
})
export class CardExpandedComponent {
  cardType: CardModel;
  // showExpand off so the inner card does not render its own expand icon (would loop).
  controls: ControlOptions = { ...new ControlOptions(), showExpand: false, showFlipIcon: true };

  constructor(@Inject(MAT_DIALOG_DATA) public data: CardModel) {
    this.cardType = data ?? CardExpandedComponent.emptyCard();
  }

  private static emptyCard(): CardModel {
    return new CardModel({
      cardGuid: "",
      cardId: 0,
      cardName: "",
      periodMinutes: 0,
      isMandatory: false,
      dailyPeriod: "NA",
      dailyPeriodId: 0,
      isPatientDeck: false,
      isPatientFavourite: false,
      isComplete: false,
      isUserDefined: false,
      sortOrder: 0,
      cardSessionCardId: 0,
      htmlScript: "",
      isEditableTemplate: false,
      cardDeckId: 0,
      cardCategory: new CardCategories({
        cardCategoryId: 0,
        cardCategoryName: "Code",
        cardCategoryShortDesc: "",
      }),
      cardDeckType: new CardDeckType({
        cardDeckId: 0,
        cardDeckName: "",
        cardDeckDescription: "",
      }),
    });
  }
}
